import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const CLIENT_CORE_FIELDS = gql`
  fragment ClientCoreFields on Client {
    id
    name
  }
`;

export const CLIENT_FIELDS = gql`
  ${CLIENT_CORE_FIELDS}
  fragment ClientFields on Client {
    ...ClientCoreFields
  }
`;

export const CLIENT = gql`
  ${CLIENT_FIELDS}
  query Client($id: ID!) {
    client(id: $id) {
      ...ClientFields
    }
  }
`;

export const CLIENTS = gql`
  ${CLIENT_FIELDS}
  query Clients (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    clients (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...ClientFields
        }
      }
      totalCount
    }
  }
`;

export const CREATE_CLIENT = gql`
  ${CLIENT_CORE_FIELDS}
  mutation CreateClient (
    $input: CreateClientInput!
  ) {
    createClient (
      input: $input
    ) {
      client {
        ...ClientCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_CLIENT = gql`
  ${CLIENT_CORE_FIELDS}
  mutation UpdateClient (
    $input: UpdateClientInput!
  ) {
    updateClient (
      input: $input
    ) {
      client {
        ...ClientCoreFields
      }
      ${ERRORS}
    }
  }
`;
